<template>
  <div>
    <vx-card v-show="showImportWidget">
      <div class="text-center pb-8">
        <h4 class="pb-2">You Are Uploading Contacts for Data Build</h4>
        <p class="text-dark-grey">
          This will upload your contact list and match them against any contacts
          currently in the database. 
        </p>
      </div>
      <div class="mb-8">
      
        <import-excel :onSuccess="loadDataInTable" :purpose="'data_build_import_contact_to_campaign'"
          @dataToTransfer="dataToTransfer" />
      
      </div>
    </vx-card>













    

   <vs-popup
          title="Imported Excel File To Data Build Contact Table"
          :active.sync="importCsvFileColumnsPopUp"
           :button-close-hidden="true"
          @close="closeimportCsvFileColumnsPopUp"
        >





            <template>
 <vs-row class="p-3">

              <vs-col vs-type="flex" vs-w="6">

                         <h5>Field</h5>     

               
              </vs-col>

              <vs-col vs-type="flex" vs-w="6">

                <vs-col vs-type="flex" vs-w="6">
                   <h5>Excel File </h5>
                </vs-col>

                 <vs-col vs-type="flex" vs-w="6">
                  <h5>Temp Table</h5> 
                </vs-col>
               



               
              </vs-col>
  

        
          </vs-row>
            </template>
         

            <template v-for="(temp_db, index) in count_of_csv_and_temp_db">
 <vs-row class="p-3">

              <vs-col vs-type="flex" vs-w="6">

                              {{ index }}

               
              </vs-col>

              <vs-col v-if="temp_db[0] == temp_db[1]" vs-type="flex" vs-w="6">

                <vs-col vs-type="flex" vs-w="6">
                   {{ temp_db[0] }}
                </vs-col>

                 <vs-col vs-type="flex" vs-w="6">
                   {{ temp_db[1] }}
                </vs-col>
               



               
              </vs-col>

                  <vs-col v-else class="not_matched_css" vs-type="flex" vs-w="6">

                <vs-col vs-type="flex" vs-w="6">
                   {{ temp_db[0] }}
                </vs-col>

                 <vs-col vs-type="flex" vs-w="6">
                   {{ temp_db[1] }}
                </vs-col>
               



               
              </vs-col>
 

        
          </vs-row>




            </template>

             <vs-row class="p-6">

              <vs-col vs-type="flex" vs-w="6">

                         <div class="text-center">
 <vs-button
                    class="ml-5 mb-5"
                    @click="GotoUnassociatedContactsPage"
                    >Submit</vs-button
                  >
                         </div>

               
              </vs-col>
             </vs-row>

           


        </vs-popup>



    <vx-card title="Now You Need To Select Fields To The Data Build Contact Table" class="mt-5"
      v-if="showFieldComparisionFirstTime">         


      <div class="vx-row">
        
        <div class="vx-col sm:w-1/2 w-full">
          <p>
            On the left
            are the fields from selected fields for campaign.
            On the right are the fields from the file you have uploaded.          
            <vs-icon @click="active1=!active1" style="float: right;"  size="small"  icon="info"></vs-icon>

          </p>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <vs-alert style="background:none; color:#626262;"
    :active.sync="active1"
    closable
    close-icon="cancel">
    <h6>Note :</h6>
    <p class="text-dark-grey mt-2">
      1. Fields should not be empty.
    </p>
    
    <p class="text-dark-grey">
      2. Contact required fields should be selected. <br>
      

      <p v-for="(field, index) in mandatory_fields" class="text-dark-grey ml-10">
        &#x2022; {{ field.name }}
      </p>


    </p>
    <p class="text-dark-grey">
      3. If phone is selected, then its phone type and phone code should be selected.
    </p>
    <p class="text-dark-grey">
      4. If revenue is selected, then its currency code should be selected.
    </p>
    <p class="text-dark-grey">
      5. If switchboard is selected, then its switchboard phone code should be selected.
    </p>
    <p class="text-dark-grey">
      6. If site switchboard is selected, then its site switchboard phone code should be selected.
    </p>
    </vs-alert>

         
        </div>
      </div>
        
      <div class="vx-row p-10">


        <div class="vx-col w-full md:w-1/2">
          <vs-list>
            <vs-list-header title="Database Fields" color="primary"></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <div class="vx-row" :key="index">
                <div class="vx-col w-full md:w-4/5">
                  <multiselect v-model="slot.dbfield" :options="db_options" :multiple="false"
                    group-values="column_names" group-label="group" :group-select="false" placeholder="Type to search"
                    track-by="name" label="label" style="height:70px;">
                    <span slot="noResult">Oops! No elements found. Consider changing the search
                      query.</span>
                  </multiselect>
                </div>
                <div class="vx-col w-full md:w-1/6">
                  <vs-icon size="18px" 
                  class="cursor-pointer mt-3"
                  @click="deleteColumn(slot)"
                  color="danger"
                  icon="delete"
                  :key="index + 1"
                ></vs-icon>
                </div>
              </div>
            </template>
            <span class="text-danger text-sm">{{
                validation_message
            }}</span>
          </vs-list>
        </div>
        <div class="vx-col w-full md:w-1/2">
          <vs-list>
            <vs-list-header title="Uploaded Fields" color="primary"></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <v-select label="field_name" class="pb-15 pt-15" :options="uploaded_csv_fields" :key="index"
                v-model="slot.uploadfield" style="height:70px;" />
            </template>
          </vs-list>
          

          <vs-button color="primary" icon-pack="feather" icon="icon-plus" @click="addAnother">Add another column
          </vs-button>

        </div>
        <div class="center-span mt-20">
          <vs-button @click="alterColumnNames" color="primary" type="filled">Proceed</vs-button>

  </div>

      </div>
    

    </vx-card>

  </div>
</template>

<script>
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import defineAbilitiesFor from "@/config/abilities";
// import ImportExcel from "@/components/excel/ImportExcel.vue";
import ImportExcel from "@/components/excel/ImportContactToCampaignExcel.vue";
import Prism from "vue-prism-component";
import vSelect from "vue-select";
import axios from "@/axios.js";
import _ from "lodash";
import Multiselect from "vue-multiselect";
// import MatchResults from "@/components/Match.vue"
export default {
  components: {
    ImportExcel,
    Prism,
    vSelect,
    CampaignAutocomplete,
    ClientAutocomplete,
    Multiselect
  },
  data() {
    return {
      count_of_csv_and_temp_db: [],
      importCsvFileColumnsPopUp: false,
      active1:false,
      campaignId : null,
      new_csv_field_name: null,
      addNewColumnToCsvTablePopUp: false,
      temporary_csv_columns: [],
      campaign_required: null,
      selected_campaign: [],
      user_id: null,
      user_role: null,
      companySearchComponentKey: 0,
      master_fields: [],
      client_fields: [],
      campaign_fields: [],
      csv_table_columns: [],
      selected_db_fields: [],
      abilities: null,
      table_name_exists: null,
      upload_validation: false,
      upload_validation_message: null,
      file_name: null,
      table_name: null,
      csv_filename: null,
      validation_message: "",
      fieldgroups: [],
      temp_campaign_contacts_columns: [],
      showFieldComparisionFirstTime: false,
      showImportWidget: true,
      tableData: [],
      header: [],
      sheetName: "",
      uploaded_csv_fields: [],
      uploaded_columns: [],
      db_options: [],
      core_fields: [],
      master_fields: [],
      client_fields: [],
      campaign_fields: [],
      opportunity_fields:[],
      mandatory_fields: [],
    };
  },
  mounted() {
   

  },
  watch: {},
  methods: {
        GotoUnassociatedContactsPage() {
      let self = this;
      self.importCsvFileColumnsPopUp = false;
      // window.location.replace('/import_account_to_campaign/' + this.campaignId);

       self.$router.push({
              name: "data-build-unassociated-contacts",
              params: { campaignId: self.campaignId }
            });

      },
    closeimportCsvFileColumnsPopUp (value) {
      if (!value) this.importCsvFileColumnsPopUp = true
    },
    addNewColumnToCsvTable() {
      this.new_csv_field_name = null;
      this.addNewColumnToCsvTablePopUp = true;
    },
    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    addAnother: function () {
      this.fieldgroups.push({
        dbfield: "",
        uploadfield: ""
      });
    },
    deleteColumn(slot) {
      console.log(this.fieldgroups);
      this.fieldgroups = this.fieldgroups.filter(function (ele) {
        return ele != slot;
      });
      console.log(slot);
      // this.fieldgroups.pop(slot);
    },
    submitForm() {
      let self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          this.validatetUserUploaded();
        }
      });
    },
    getSelectedMandatoryFieldsForBuild() {
      let self = this;
      let selected_campaign_id = self.campaignId
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedMandatoryFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);

          if (result.length != 0) {


          self.mandatory_fields = result.filter(ele => ele.level == 'contact' || ele.level == 'opportunity' );

          self.mandatory_fields = self.mandatory_fields.filter(ele => ele.field_id == 'ec41e532-632d-4323-8071-f60b4543a68a' || ele.field_id == '02c30710-62f3-4cbd-92a6-db08d3fc5c5f' );


          console.log("Mandatory Fields: ", self.mandatory_fields);

          }

        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    getAllSelectedFieldsForCampaign() {
      let self = this;
      let level = "contact";
      let campaign_id = self.campaignId
      axios
        .get(
          this.$base_url + "/api/contacts/get_campaign_selected_fields_to_upload_contact/" +
          level + '/' + campaign_id
        )
        .then(response => {
          if (response) {
            if (response.data){

              let result = JSON.parse(response.data);

             


  result.forEach(function (ele) {
  ele.label = ele.name;
  let ele_name = ele.name;
  ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
  ele.value = ele.name;
  if(ele.field_type == 'core_field'){
    ele.group = "Core Fields";
    self.core_fields.push(ele)
  }

  if(ele.field_type == 'master_field'){
    ele.group = "Master Fields";
    self.master_fields.push(ele)
  }

  if(ele.field_type == 'client_field'){
    ele.group = "Client Fields";
    self.client_fields.push(ele)
  }

  if(ele.field_type == 'campaign_field'){
    ele.group = "Campaign Fields";
    self.campaign_fields.push(ele)
  }

  // if(ele.field_type == 'opportunity_field'){
  //   ele.group = "Opportunity Fields";
  //   self.opportunity_fields.push(ele)
  // }
 
  
 
  
});

let coreField = {
  group: "Core Fields",
  column_names: self.core_fields
};

let MasterField = {
  group: "Master Fields",
  column_names: self.master_fields
};

let ClientField = {
  group: "Client Fields",
  column_names: self.client_fields
};

let CampaignField = {
  group: "Campaign Fields",
  column_names: self.campaign_fields
};

// let OpportunityField = {
//   group: "Opportunity Fields",
//   column_names: self.opportunity_fields
// };

self.db_options.push(coreField);
self.db_options.push(MasterField);
self.db_options.push(ClientField);
self.db_options.push(CampaignField);
// self.db_options.push(OpportunityField);

console.log("Opportunity"  , self.opportunity_fields);
}

            }
       
        })
        .catch(error => {
          console.log(error);
        });
    },
    alterColumnNames() {
      this.$vs.loading();
      this.fieldgroups[0].intial_selected_csv_columns = JSON.stringify(
        this.fieldgroups
      );
      let selected_db_columns = []
      this.fieldgroups.forEach(function (ele) {
        selected_db_columns.push(ele['dbfield']['name'])
      })
      this.fieldgroups[0].selected_columns = JSON.stringify(
        selected_db_columns
      );
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.fieldgroups[0].csv_filename = this.csv_filename;
      this.fieldgroups[0].table_name =
        'temp_data_build_' + this.campaignId.replaceAll("-","_") + "_contacts";
      this.fieldgroups[0].campaign_id = this.campaignId;
      this.fieldgroups[0].user_info = userInfo;
      let self = this;
      let fields_result = this.fieldgroups.map(({ dbfield }) => dbfield);
      fields_result.forEach(function (ele) {
        self.selected_db_fields.push(ele.name);
      });


      

      axios
        .post(
          this.$base_url + "/api/contacts/data_build_alter_column_names_import_contact_to_campaign",
          this.fieldgroups
        )
        .then(response => {
          if (response.data.status == "success") {
            self.importCsvFileColumnsPopUp = true;

            self.count_of_csv_and_temp_db = response.data.data.count_of_csv_and_temp_db;
     



            // self.$router.push({
            //   path: `/import_contact_to_campaign/` + self.campaignId
            // });

          }
          else if (response.data.status == "error_importing") {
            self.$vs.loading.close();
            self.$router.push({
              path: `/data_build_import_contact_to_campaign/` + self.campaignId
            });
          }
          else if (response.data.status == "not_empty") {
            this.validation_message = response.data.message;
            console.log(response.data.message);
          } else if (response.data.status == "phone_and_phone_type") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          } else if (response.data.status == "switchboard_and_switchboard_phone_code") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          } else if (response.data.status == "site_switchboard_and_site_switchboard_phone_code") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          } else if (response.data.status == "revenue_and_currency_code_key") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          }
          else if (response.data.status == "reg_no_or_country") {
            this.validation_message = response.data.message;
          }
          self.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
  
    loadDataInTable(uploaded_column_names){

      console.log("uploaded_column_names" , uploaded_column_names)

     
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    dataToTransfer(value) {
      let self = this

      this.uploaded_column_names = value.uploaded_column_names;
      this.campaignId = value.campaignId;
      this.csv_filename = value.csv_filename;


      this.getAllSelectedFieldsForCampaign()
      this.getSelectedMandatoryFieldsForBuild()


      this.uploaded_column_names.forEach(function (el) {
  

  self.fieldgroups.push(
  {
    dbfield: "",
    uploadfield: el
  }
  )

  


});



this.uploaded_csv_fields = this.uploaded_column_names;
this.showImportWidget = false;
this.upload_validation = true;
this.showFieldComparisionFirstTime = true;
    }
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.center-span {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.not_matched_css {
  background-color: #ebdcdc;
  color: #110101;
}
</style>
